import { render, staticRenderFns } from "./istshhad-info.vue?vue&type=template&id=2799fb3a&"
import script from "./istshhad-info.vue?vue&type=script&lang=js&"
export * from "./istshhad-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports